@let tp = 'features.auditLogs.details';
@let createdAt = data.createdAt | serverDateTime;

<ng-container *transloco="let t">
  <div class="header-with-action">
    <h2 class="text-break" mat-dialog-title>{{ t(`${tp}.title`, { entity: data.entity }) }}</h2>

    <button color="primary" mat-dialog-close mat-icon-button type="button">
      <mat-icon svgIcon="close" />
    </button>
  </div>

  <mat-dialog-content>
    <p>{{ t(`${tp}.description`, { event: data.event, user: data.user, createdAt }) }}</p>

    <mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="fieldName">
        <mat-header-cell *matHeaderCellDef>{{ t(`${tp}.headers.fieldName`) }}</mat-header-cell>

        <mat-cell *matCellDef="let element">{{ element.fieldName }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="oldValue">
        <mat-header-cell *matHeaderCellDef>{{ t(`${tp}.headers.oldValue`) }}</mat-header-cell>

        <mat-cell *matCellDef="let element" class="text-break">
          <ng-container *ngTemplateOutlet="fieldValue; context: { $implicit: element.oldValue }" />
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="newValue">
        <mat-header-cell *matHeaderCellDef>{{ t(`${tp}.headers.newValue`) }}</mat-header-cell>

        <mat-cell *matCellDef="let element" class="text-break">
          <ng-container *ngTemplateOutlet="fieldValue; context: { $implicit: element.newValue }" />
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns" class="compact" />

      <mat-row *matRowDef="let _; columns: displayedColumns" class="compact mobile-padding" />

      <mat-footer-row
        *matFooterRowDef="['noData']"
        [class]="{
          'd-none': dataSource.data.length > 0,
        }"
      />

      <ng-container matColumnDef="noData">
        <mat-footer-cell *matFooterCellDef [attr.colspan]="displayedColumns.length">
          {{ t('common.noDataToDisplay') }}
        </mat-footer-cell>
      </ng-container>
    </mat-table>
  </mat-dialog-content>

  <ng-template #fieldValue let-value>
    @if (value | isNil) {
      <span class="hint">{{ t(`${tp}.unsetValue`) }}</span>
    } @else if (value | isEmpty) {
      <span class="hint">{{ t(`${tp}.emptyValue`) }}</span>
    } @else if (value | isValidIsoString) {
      {{ value | serverDateTime }}
    } @else {
      {{ value }}
    }
  </ng-template>
</ng-container>
